// Small client-side store. Server state belongs to TanStack Query — this store
// only holds UI preferences and the cross-screen "currently selected camera".
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export const useAppStore = create()(persist((set) => ({
    selectedCameraId: null,
    setSelectedCameraId: (id) => set({ selectedCameraId: id }),
    persona: null,
    setPersona: (p) => set({ persona: p }),
    authToken: null,
    setAuthToken: (t) => set({ authToken: t }),
    currentUser: null,
    setCurrentUser: (u) => set({ currentUser: u }),
    activityLog: [],
    pushActivity: (e) => set((s) => ({
        activityLog: [
            { id: crypto.randomUUID(), ts: Date.now(), ...e },
            ...s.activityLog,
        ].slice(0, 100),
    })),
    clearActivity: () => set({ activityLog: [] }),
}), {
    name: 'eyva-ui',
    partialize: (s) => ({
        selectedCameraId: s.selectedCameraId,
        persona: s.persona,
    }),
}));
